
import { Vue, Component } from 'vue-property-decorator';
import { getCompanyList } from '../api';
import { List } from 'vant';
Vue.use(List);
@Component
export default class Home extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  show: boolean = true;

  addrsTypes = [
    { id: 1, name: '市级机构' },
    { id: 2, name: '区县级机构' },
    { id: 3, name: '其他' },
  ];
  currentInx: number = 1;

  goMiNi() {
    // this.$router.push('empty');
    window.location.href = 'https://appwxsmad5a1601.h5.xiaoeknow.com/p/decorate/page/eyJpZCI6NDA4NjYzMCwiY2hhbm5lbF9pZCI6IiJ9?share_user_id=u_636672bca5c44_BkjBsWTTph&share_type=5&wework_share_customer_id=u_636672bca5c44_BkjBsWTTph&entry=2&entry_type=2002';
  }

  onLoad() {
    getCompanyList(this.page, this.currentInx).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    this.finished = true;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  changeorder(teamid: number) {
    if (this.currentInx === teamid) {
      return;
    }
    this.page = 1;
    this.list = [];
    this.currentInx = teamid;
    this.onLoad();
  }
  reset() {
    this.list = [];
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 50);
  }
}
